import Storage from 'store'

// getters是store 的计算属性
export default {
  // lang: state => {
  //   return VueCookies.get('local')
  // },
  // token: state => {
  //   return document
  // },
  regionList: state => state.regionList,
  locale: state => state.locale,
  // 店铺货币
  storeCurrency(state) {
    const regs = JSON.parse(Storage.get('regionList'))
    const storeRid = state.storeRegionId
    return regs.find(c => c.regionId === Number(storeRid))?.currencySymbol || 'KSh'
  },
  localeList: state => state.locales || [],
  whatsappNumber: state => {
    return state.storeInfo?.whatsapp || ''
  }
}
